/** @flow */
import * as React from 'react';
import styled from 'styled-components';
import NextPageIcon from '@material-ui/icons/NavigateNext';
import PreviousPageIcon from '@material-ui/icons/NavigateBefore';
import FontIcon from 'material-ui/FontIcon/FontIcon';

import { Footer } from 'statsradio/themes/v2/Stylesheet';
import Paging from 'statsradio/modules/pagination/domain/paging';

const Wrapper = styled.div`
  display: flex;
  align-items:center;
`;

const PageNum = styled.div`
  padding: 2px;
  cursor: pointer;
  color: #4c4c4c;
`;

const CurrentPageNum = styled(PageNum)`
  color: ${({ theme }) => theme.V2.colors.primary}; 
  font-weight: bold;
  cursor: default;
`;

const PageSelectionIconWrapper = styled.div`
  display: flex;
  cursor: pointer;
  min-width: 20px;
`;
const PageChangerButton = styled(FontIcon)`
  font-size: 10px;
  padding: 0px 5px 0px 3px;
  display: flex;
  align-items: center;
`;

export const SWITCH_PAGE_FOOTER_ID = 'SWITCH_PAGE_FOOTER_ID';
export const NEXT_PAGE_SELECTOR = 'NEXT_PAGE_SELECTOR';
export const PREVIOUS_PAGE_SELECTOR = 'PREVIOUS_PAGE_SELECTOR';
const MAX_PAGE_NUMBER = 5;

interface Props {
  className: string;
  paging: Paging;
  onPageChange: (page: number) => void;
}

class SwitchPageFooter extends React.Component<Props> {

  getPageLink(pageNumber: number) {
    const { paging, onPageChange } = this.props;
    const isSelected = paging.currentPage === pageNumber;

    if (pageNumber > MAX_PAGE_NUMBER) {
      return null;
    }

    if (isSelected) {
      return (<CurrentPageNum key={`selected_${pageNumber}`}>{pageNumber}</CurrentPageNum>);
    }
    return <PageNum key={`page_${pageNumber}`} onClick={() => onPageChange(pageNumber)}>{pageNumber}</PageNum>;
  }

  onPreviousPage = () => {
    this.props.onPageChange(this.props.paging.goToPrevious());
  };
  onNextPage = () => {
    this.props.onPageChange(this.props.paging.goToNext());
  };

  render() {
    const { className, paging } = this.props;

    const pages = Array(paging.numberOfPages).fill();
    const displayNextPageSelector = paging.canGoToNext() && paging.currentPage < MAX_PAGE_NUMBER;
    return (
      <Footer className={className}>
        {paging.isRequired() &&
        <Wrapper id={SWITCH_PAGE_FOOTER_ID}>
          <PageSelectionIconWrapper>
            {paging.canGoToPrevious() &&
            <PageChangerButton id={PREVIOUS_PAGE_SELECTOR} onClick={this.onPreviousPage}>
              <PreviousPageIcon fontSize={'small'} />
            </PageChangerButton>
            }
          </PageSelectionIconWrapper>

          {pages.map((_, i) => this.getPageLink(i + 1))}

          <PageSelectionIconWrapper>
            {displayNextPageSelector &&
            <PageChangerButton id={NEXT_PAGE_SELECTOR} onClick={this.onNextPage}>
              <NextPageIcon fontSize={'small'} />
            </PageChangerButton>
            }
          </PageSelectionIconWrapper>
        </Wrapper>
        }
      </Footer>
    );
  }
}

export default SwitchPageFooter;



// WEBPACK FOOTER //
// ./src/statsradio/modules/salesDashboard/components/SwitchPageFooter.js